import React from 'react';
import { styled } from 'linaria/react';
import { Link } from 'react-router-dom';
import Image from '@jetshop/ui/Image';

const ImageWrapper = styled('div')`
  img {
    width: 100%;
    max-width: 100%;
    display: block;
  }
`;

export const CompImage = ({ link, url, aspect, alt }) => (
  <ImageWrapper>
    {link ? (
      <Link to={link}>
        <Image aspect={aspect} src={url} />
      </Link>
    ) : (
      <img
        alt={alt || link}
        crop
        src={url + '?extend=copy&width=1500&method=thumbnail'}
      />
    )}
  </ImageWrapper>
);

export default CompImage;
